import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=3ce17af6&scoped=true&"
import script from "./InputForm.vue?vue&type=script&lang=ts&"
export * from "./InputForm.vue?vue&type=script&lang=ts&"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=3ce17af6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce17af6",
  null
  
)

export default component.exports